<template>
  <div class="row">
    <div class="col-12">
      <card>
        <div class="card-body">
          <h2 class="mt-0 pt-0">
            <i class="fas fa-user-cog text-primary"></i>{{$t('user.title')}}
            <router-link :to="{ name: 'user_new' }" class="btn btn-primary float-right">{{$t('user.button.addnew')}}</router-link>
          </h2>
          <hr>
          <div slot="raw-content" class="table-responsive">
            <paper-table
              :data="users"
              :columns="columns"
              :column_names="column_names"
              type="hover"
              edit_route="user_edit"
              delete_route="user_delete"
            ></paper-table>
          </div>
        </div>
      </card>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import PaperTable from "../../components/PaperTable";
const tableColumns = ["Id", "Name", "Email", "ASF", "Role"];

export default {
  components: {
    PaperTable
  },
  computed: {
    ...mapState("users", {
      users: "all"
    })
  },
  data() {
    return {
      columns: [...tableColumns],
      column_names: [
        "Id",
        this.$t('user.name'),
        this.$t('user.email'),
        this.$t('user.asf'),
        this.$t('user.role'),
      ]
    };
  },
  console: () => console,
  mounted() {
    this.$store.dispatch("users/getAllUsers");
    // console.log(this.$store.dispatch("users/getAllUsers"));
  }
};
</script>
<style>
</style>
